
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const Colors = ({ t }) => {
    const colors = t('media_kit:colors', {}, { returnObjects: true });
    return (<section className={'logos colors'}>
            <div className="container">
                <h2 className={'logos_title'}>{colors.title}</h2>
                <div className="logos_wrapper">
                    <ul className={'colors_list'}>
                        <li className={'colors_list_item'}>
                            <div className={'item_color'}/>
                            <h3 className={'item_title'}>Light Cyan</h3>
                            <p className={'item_code'}>#89EFFC</p>
                        </li>
                        <li className={'colors_list_item'}>
                            <div className={'item_color'}/>
                            <h3 className={'item_title'}>Light Blue</h3>
                            <p className={'item_code'}>#89BFFC</p>
                        </li>
                        <li className={'colors_list_item'}>
                            <div className={'item_color'}/>
                            <h3 className={'item_title'}>Deep Blue</h3>
                            <p className={'item_code'}>#150EBE</p>
                        </li>
                        <li className={'colors_list_item'}>
                            <div className={'item_color'}/>
                            <h3 className={'item_title'}>Light Purple</h3>
                            <p className={'item_code'}>#EFA4FB</p>
                        </li>
                        <li className={'colors_list_item'}>
                            <div className={'item_color'}/>
                            <h3 className={'item_title'}>White</h3>
                            <p className={'item_code'}>#FFFFFF</p>
                        </li>
                    </ul>
                </div>
            </div>
        </section>);
};
export default Colors;

    async function __Next_Translate__getStaticProps__19763359636__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//media_kit/Colors/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19763359636__ as getStaticProps }
  